import React, { useState } from "react";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";
//
import { fetcher } from "../../../utils/react-query";
import { DEFAULT_PER_PAGE } from "../../../helpers/default";
import { generateParams, labelTranslates } from "../../../utils/filtering";
import {
  handleKeyDown2,
  onChangeUseState,
} from "../../../helpers/FunctionsGlobal";
//
import Container from "../../../components/Layout/Container";
import ContentBlock from "../../../components/Layout/ContentBlock";
import FilterMenu from "../../../components/Layout/FilterMenu";
import TableFilterBox from "../../../components/common/TableFilterBox";
import ContentValidation from "../../../components/common/ContentValidation";
import { Pagination, TextInput } from "../../../components/globals";
import { useFetch, useModal } from "../../../hooks";
import ModalSimple from "../../../components/Layout/Modals/ModalSimple";
import { Button, Checkbox, Form, Input, Select, Tooltip } from "antd";
import { AiOutlineInfoCircle } from "react-icons/ai";
import Axios from "axios";
import { antdMessageError, antdMessageSuccess } from "../../../helpers/Utils";
import Spinner from "../../../components/common/Spinner";
import { ButtonDelete, ButtonSmall } from "../../../components/common/Buttons";
import { IconSearch } from "../../../components/Layout/Icons";
import AntdConfirm from "../../../helpers/AntdConfirm";
import { GoCheck } from "react-icons/go";

const queryPickupUsersClient = new QueryClient();

const initialFilters = {
  email_i_cont_any: "",
  title_cont: "",
};

function TechnoramaPickupUsersPage({ match }) {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(DEFAULT_PER_PAGE);
  const [filters, setFilters] = useState(initialFilters);
  const [filterStr, setFilterStr] = useState("");

  const { modalOpt, setModalOpt, closeModal } = useModal();

  const { data: { data: pickup_addresses = [] } = {} } = useQuery({
    queryKey: [
      "pickup_addresses",
      {
        page: 1,
        perPage: 10000,
        filterStr:
          "q[technorama_true]=1&q[company_cont]=Technorama&tch_departments=1",
      },
    ],
    queryFn: fetcher,
    staleTime: 10000,
  });
  const {
    isLoading,
    error,
    data: { totals = 0, data = [] } = {},
    refetch,
  } = useQuery({
    queryKey: ["pickup_users", { page, perPage, filterStr }],
    queryFn: fetcher,
  });

  const handler = () => {
    if (generateParams(filters) == filterStr && page == 1) {
      return refetch();
    }
    setFilterStr(generateParams(filters));
    setPage(1);
  };

  const mutationDelete = useMutation({
    mutationFn: (record_id) =>
      Axios({
        url: `/api/v1/pickup_users/${record_id}`,
        method: "DELETE",
      }).then((res) => res.data),
    onSuccess: () => {
      refetch();
      antdMessageSuccess();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  return (
    <Container
      location={{
        locationName: "Pickup users",
        locationUrl: match.url,
      }}
      breadcrumbs={[
        {
          label: "Technorama",
          value: "#",
        },
        {
          label: "Pickup users",
          value: match.url,
        },
      ]}
    >
      <ContentBlock>
        <FilterMenu
          text2="Pickup users"
          totals={totals}
          length={data.length}
          onChangeCountPage={setPerPage}
          countPage={perPage}
          page={page}
        />
      </ContentBlock>
      <ContentBlock containerClass={"py-1"}>
        <TableFilterBox
          add={() => setModalOpt("new")}
          filter={true}
          onFilter={() => handler()}
          clearFilter={() => setFilters(initialFilters)}
        >
          {Object.entries(filters).map(([name, value]) => (
            <div className="px-1">
              <TextInput
                text={labelTranslates[name]}
                name={name}
                style={{ width: 165 }}
                onKeyDown={handleKeyDown2(handler)}
                value={value}
                onChange={onChangeUseState(setFilters)}
              />
            </div>
          ))}
        </TableFilterBox>
        <ContentValidation loader={isLoading} array={data} error={error}>
          <div className="table-responsive" style={{ overflow: "hidden" }}>
            <table className="table mt-3">
              <thead>
                <tr className="text-muted">
                  <th className="text-black">Email</th>
                  <th className="text-black">Firstname Lastname</th>
                  <th className="text-black">Has actions</th>
                  <th className="text-black">Admin</th>
                  <th className="text-black">Can handover</th>
                  <th className="text-black">Departments</th>
                  <th className="text-black"></th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => {
                  return (
                    <tr className="align-middle tableColumn" key={item.id}>
                      <td className="align-middle">{item.email}</td>
                      <td className="align-middle">{item.title}</td>
                      <td className="align-middle">
                        {item.has_actions && (
                          <GoCheck className={"text-success"} />
                        )}
                      </td>
                      <td className="align-middle">
                        {item.is_admin && (
                          <GoCheck className={"text-success"} />
                        )}
                      </td>
                      <td className="align-middle">
                        {item.can_handover_without_prepared && (
                          <GoCheck className={"text-success"} />
                        )}
                      </td>
                      <td className="align-middle">
                        {pickup_addresses
                          .filter(({ value }) =>
                            item.pickup_address_ids.includes(value)
                          )
                          .map(({ label }) => label)
                          .join(", ")}
                      </td>
                      <td className="align-middle">
                        <div
                          className="d-flex justify-content-end"
                          style={{
                            gap: 5,
                          }}
                        >
                          <ButtonSmall
                            onClick={() => {
                              setModalOpt("edit", item.id);
                            }}
                          >
                            <IconSearch color="#fff" />
                          </ButtonSmall>
                          <ButtonDelete
                            disabled={mutationDelete.isLoading}
                            onDelete={() => {
                              AntdConfirm({
                                onOk: () => {
                                  mutationDelete.mutate(item.id);
                                },
                              });
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Pagination
              setPagination={setPage}
              page={page}
              totals={totals}
              pageCount={perPage}
            />
          </div>
        </ContentValidation>
      </ContentBlock>
      {modalOpt?.type && (
        <ModalPickupUser
          modalOpt={modalOpt}
          onClose={closeModal}
          pickup_addresses={pickup_addresses}
        />
      )}
    </Container>
  );
}

export default ({ match }) => {
  return (
    <QueryClientProvider client={queryPickupUsersClient}>
      <TechnoramaPickupUsersPage match={match} />
    </QueryClientProvider>
  );
};

const ModalPickupUser = ({ modalOpt, onClose, pickup_addresses }) => {
  const { value, loading } = useFetch(
    `/api/v1/pickup_users/${modalOpt.type == "edit" ? modalOpt.record_id : "new"
    }`
  );

  const [form] = Form.useForm();
  const utils = useQueryClient();
  const mutation = useMutation({
    mutationFn: (pickup_user) => {
      return Axios({
        method: value.id ? "PUT" : "POST",
        url: `/api/v1/pickup_users/${value.id ? value.id : ""}`,
        data: {
          pickup_user,
        },
      }).then((res) => res.data);
    },
    onSuccess: async () => {
      await utils.invalidateQueries(["pickup_users"]);
      antdMessageSuccess();
      onClose();
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  return (
    <ModalSimple
      text={modalOpt.type === "edit" ? "Edit" : "Create new"}
      onClose={onClose}
      hide={true}
    >
      {loading ? (
        <Spinner />
      ) : (
        <Form
          form={form}
          layout="vertical"
          name="basic"
          initialValues={{ ...value, password: "", confirm_password: "" }}
          onFinish={(values) => {
            console.log({ values });
            if (values.password !== values.confirm_password) {
              return form.setFields([
                {
                  name: "confirm_password",
                  errors: ["Invalid confirm password"],
                },
              ]);
            }
            delete values.confirm_password;
            if (!values.password) {
              delete values.password;
            }
            mutation.mutate(values);
          }}
          autoComplete="off"
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input type="email" placeholder="Type in" />
          </Form.Item>

          <Form.Item
            label="Firstname and lastname"
            name="title"
            rules={[
              {
                required: true,
                message: "Please input your Firstname and lastname!",
              },
            ]}
          >
            <Input placeholder="Type in" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={
              modalOpt.type == "edit"
                ? null
                : [
                  {
                    required: true,
                    message: "Please input your password",
                  },
                ]
            }
          >
            <Input.Password placeholder="Type in" />
          </Form.Item>
          <Form.Item label="Confirm password" name="confirm_password">
            <Input.Password placeholder="Type in" />
          </Form.Item>

          <Form.Item label="Departments" name="pickup_address_ids">
            <Select mode="multiple" placeholder="Select">
              {pickup_addresses.map(({ label, value }) => (
                <Select.Option key={value} value={value}>
                  {label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="has_actions" valuePropName="checked">
            <Checkbox>Has actions</Checkbox>
          </Form.Item>

          <Form.Item name="is_admin" valuePropName="checked">
            <Checkbox>Admin</Checkbox>
          </Form.Item>

          <Form.Item name="can_handover_without_prepared" valuePropName="checked">
            <Checkbox>
              Can hand over without prepared{" "}
              <Tooltip title="Allows this user to mark an order as handed over 'atiduota' without first marking it as prepared 'suruošta'. By default, all users must first mark an order as prepared (which sends an SMS to the customer) before they can hand it over.">
                <AiOutlineInfoCircle style={{ color: '#1890ff', cursor: 'pointer', marginLeft: 4 }} />
              </Tooltip>
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              className="w-100"
              type="primary"
              htmlType="submit"
              disabled={mutation.isLoading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      )}
    </ModalSimple>
  );
};
